import { Box, TextField, withStyles } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import QueryString from "query-string";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useRouteMatch } from "react-router-dom";
import {
  setBlogFetchter,
  setEmpFetchter,
  setEnqFetchter,
  setInvFetchter,
} from "../../Stores/Filter/actions";
import { setActiveLocation } from "../../Stores/SlickCareProfiles/actions";
import { commonStyle } from "../../commonStyle";
import { useStyles } from "./style";

const StyledAutocomplete = withStyles({
  root: {
    background: "#fff",
    color: "#2563eb",
    borderRadius: "6px",
    border: "1px solid #2563eb",
  },
})(Autocomplete);

const StyledTextField = withStyles({
  root: {
    "& *": {
      color: "#2563eb",
    },
    "& .MuiOutlinedInput-root": {
      fontSize: "16px",
      fontWeight: "bold",
    },
    "& .MuiAutocomplete-input": {
      padding: `2.5px 4px !important`,
    },
  },
})(TextField);

const LocationToggler = ({ history, onLocationChange }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const query = QueryString.parse(window.location.search);
  const { id } = useParams();

  const commonClasses = commonStyle();

  const { activeLocation, userLocations } = useSelector(
    (state) => state.SlickCareProfilesReducer,
  );

  const isLocationEdit = useRouteMatch("/d/location/edit/:id")?.isExact;
  const isProfile = useRouteMatch("/d/location/edit/:id/:type");
  const isWebEnq = useRouteMatch("/d/location/edit/:id/:type/:reportType");

  let list = [
    "/d/review/listing",
    "/d/review/review-card",
    "/d/review/review-poster",
    "/d/review/review-upload",
    "/d/review/export",
    "/d/review/invites",
    "/d/review/packages/order-history",

    "/d/leads/all",
    "/d/leads/prospecting",
    "/d/leads/firstcontact",
    "/d/leads/viewing",
    "/d/leads/viewingoutcome",
    "/d/leads/assessment",
    "/d/leads/assessmentoutcome",
    "/d/leads/closed",
    "/d/leads/reports/dashboard",
    "/d/leads/reports/close",
    "/d/leads/reports/acquisition",
    "/d/leads/reports/geography",
    "/d/leads/task",
    "/d/leads/networking",

    "/d/engage/reports/view/dashboard",
    "/d/engage/reports/view/overview",
    "/d/engage/reports/view/headlines",
    "/d/engage/reports/view/action",
    "/d/engage/employees",
    "/d/engage/residents",
    "/d/engage/pulse",

    "/d/home",
    "/d/account-users/staff",
    "/d/survey",

    "/d/rota",
    "/d/rota/month",
    "/d/rota/availability",
    "/d/rota/extra-time",

    "/d/leave",

    "/d/hr/employee",

    "/d/timesheet/list",
    "/d/timesheet/clock",
    "/d/timesheet/allocation",
    "/d/rota/budget",
    "/d/users",

    "/d/rota/terminal",
    "/d/r/team",
  ];

  const handleRoute = (location) => {
    dispatch(setActiveLocation(location));

    let path = history?.location?.pathname;

    if (
      list.findIndex((listPath) => listPath === path?.replaceAll(" ", "")) >= 0
    ) {
      history.push(`${path}?location_id=${location?.id}`);
    }

    if (isLocationEdit) {
      history.push(`/d/location/edit/${location?.id}`);
    }

    if (isProfile) {
      history.push(
        `/d/location/edit/${location?.id}/${isProfile?.params?.type}`,
      );
    }

    if (isWebEnq) {
      history.push(
        `/d/location/edit/${location?.id}/${isWebEnq?.params?.type}/${isWebEnq?.params?.reportType}`,
      );
    }

    dispatch(setEmpFetchter(false));
    dispatch(setBlogFetchter(false));
    dispatch(setInvFetchter(false));
    dispatch(setEnqFetchter(false));
  };

  useEffect(() => {
    if (
      Object.keys(query).length > 0 &&
      query?.location_id !== activeLocation?.id
    ) {
      let currLoc = userLocations.find((ele) => ele.id === query?.location_id);
      if (currLoc?.id) {
        dispatch(setActiveLocation(currLoc));
      }
    } else {
      if (id !== activeLocation?.id) {
        let currLoc = userLocations.find((ele) => ele.id === id);
        if (currLoc?.id) {
          dispatch(setActiveLocation(currLoc));
        }
      }
    }
  }, []);

  return (
    <div className={classes.locationWrapper}>
      <div
        className={commonClasses.flexBox}
        style={{
          flexWrap: "nowrap",
          alignItems: "center",
        }}
      >
        <div className={`${classes.selector} ${commonClasses.flexItemLG}`}>
          <StyledAutocomplete
            options={userLocations ?? []}
            disableClearable={true}
            renderOption={(option) => (
              <Box>{option.id && option.title ? option.title : ``}</Box>
            )}
            getOptionLabel={(option) => (option?.id ? option.title : "")}
            getOptionSelected={(option, value) => value?.id === option?.id}
            style={{ width: "100%" }}
            value={activeLocation}
            onChange={(event, newValue) => {
              onLocationChange && onLocationChange(newValue);
              handleRoute(newValue);
            }}
            renderInput={(params) => (
              <StyledTextField
                {...params}
                placeholder="Location"
                variant="outlined"
                size="small"
                id="standard-basic"
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    input: {
                      fontSize: `12px`,
                    },
                  },
                }}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(LocationToggler);
